import React, { FC, useCallback } from 'react';
import { Tab } from 'semantic-ui-react';
import { FilterGroupItem } from '../../../interfaces/POSGroupFilter';

import './GroupFilter.less';
import { POSLoadingIndicator } from '../../../index';

export interface Props {
  filterItems?: FilterGroupItem[];
  tabPaneLoadingText?: string;
}

export const GroupFilterCustomTabPane: FC<Props> = ({
  filterItems,
  tabPaneLoadingText,
}) => {
  const getLoadingText = useCallback(() => {
    if (tabPaneLoadingText) {
      return tabPaneLoadingText;
    } else if (filterItems && filterItems.length == 0) {
      return (
        <>
          Sorry, we were not able to find a match with your search.
          <br />
          <b>Please check your spelling</b> OR <b>try another search.</b>
        </>
      );
    }
    return '';
  }, [filterItems, tabPaneLoadingText]);

  const renderLoadingIcon = useCallback(() => {
    return (
      <div className="empty-pane">
        <POSLoadingIndicator />
        {getLoadingText()}
      </div>
    );
  }, [getLoadingText]);

  return (
    <Tab.Pane>
      {filterItems && filterItems.length > 0 ? (
        <div className="custom-fields">
          {filterItems.map((filterItem) => {
            if (!filterItem.content) {
              return;
            }
            return <div key={filterItem.itemId}> {filterItem.content}</div>;
          })}
        </div>
      ) : (
        renderLoadingIcon()
      )}
    </Tab.Pane>
  );
};
